import ContactSection from "../component/ContactSection"
import FAQsPrivacyPolicy from "../component/FAQsPrivacyPolicy"
import PrivacyIntro from "../component/PrivacyIntro"
import PrivacyHero from "../component/PrivacyPolicyHero"

const PrivacyPolicy = () => {
  return (
    <>
    <PrivacyHero/>
    <PrivacyIntro/>
    <FAQsPrivacyPolicy/>
    <ContactSection/>
    </>
  )
}

export default PrivacyPolicy